import axios from './request'

export const Postlogin = (params)=>axios.post('/login',params)//登录
export const PostmsgLogin = (params)=>axios.post('/msgLogin',params)//短信登录
export const PostupdatePass = (params)=>axios.post('/updatePass',params)//忘记密码
export const GetrecentlyClass = (params)=>axios.get('/theClass!api/recentlyClass?studentId='+params.id)//获取首页班级列表
export const GetgetOrganizationTree = ()=>axios.get('/theClass!api/getOrganizationTree')//获取注册页单位组织树
export const GetisAlreadyClass = (params)=>axios.get('/theClass!api/isAlreadyClass?phoneNum='+params.phone)//个人中心页班级列表
export const GedoSendMsg = (params)=>axios.get('/msg!api/doSendMsg?phoneNum='+params.phone)//发短信
export const GetclassDetail = (params)=>axios.get('/theClass!api/classDetail?phoneNum='+params.phone+"&classId="+params.classId)//已报名班级详情
export const GetnoLoginClassDetail = (params)=>axios.get('/theClass!api/noLoginClassDetail?classId='+params.classId)//未报名班级详情
export const GetgetQuestion = (params)=>axios.get('/theClass!api/getQuestion?classId='+params.classId)//获取问卷
export const GetwillBePay = (params)=>axios.get('/theClass!api/willBePay?classId='+params.classId+"&studentId="+params.id)//付费通知
export const PostisDownloadCer = (params)=>axios.post('/theClass!api/isDownloadCer?classId='+params.classId+"&studentId="+params.id)//下载证书通知后台
export const PostinitStudent = (params)=>axios.post('/theClass!api/initStudent',params)//注册
export const GetgetNations = ()=>axios.get('/theClass!api/getNations')//获取注册页民族

//报名
export const PostsignUpClass = (params,headers)=>axios({
    method:'post',
    url:'/theClass!api/signUpClass',
    data:params,
    headers:headers
})
//问卷评估提交
export const PostanswerTheQuestions = (params,headers)=>axios({
    method:'post',
    url:'/theClass!api/answerTheQuestions',
    data:params,
    headers:headers
})
